import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class PurchaseKsefNumberInvalidError extends Violation {
    public constructor() {
        super(ViolationSeverity.Error, 'scenes.e-invoices-received.service.dialogs.download-headers.validations.invalid-ksef-number');
    }
}
